module.exports = __webpack_public_path__ + "static/media/lookingToBecomeAProvider.ae561725.svg";